import React, { Component } from "react";
import { Route, Router, Switch } from "react-router-dom";
import WhitelabelAppProvider from "./components/WhitelabelAppProvider";
import browserHistory from "./browserHistory";
import UserRoutesContainer from "./UserRoutesContainer";
import CheckBrowserContainer from "./core/CheckBrowserContainer";
import CheckBrowserVersionContainer from "./core/CheckBrowserVersionContainer";
import CheckAudioPermissionContainer from "./core/CheckAudioPermissionContainer";
import RequireDesktop from "./core/RequireDesktop";
import LoginScene from "./screens/login/LoginScene";
import Async from "./core/Async";
import FlexgeLogo from "./images/flexge-logo.png";
import WhitelabelConfig from "./wl.config.json";

class App extends Component {
  render() {
    return (
      <WhitelabelAppProvider
        defaultLogo={FlexgeLogo}
        whitelabelConfigs={WhitelabelConfig}
        host={process.env.REACT_APP_API_URL}
      >
        {({ isLoading }) => (
          <Async fetching={isLoading}>
            <RequireDesktop allowedRoutes={[]}>
              <CheckBrowserContainer allowedRoutes={[]}>
                <CheckBrowserVersionContainer>
                  <CheckAudioPermissionContainer>
                    <Router history={browserHistory}>
                      <Switch>
                        <Route path="/login" component={LoginScene} />
                        <Route path="/" component={UserRoutesContainer} />
                      </Switch>
                    </Router>
                  </CheckAudioPermissionContainer>
                </CheckBrowserVersionContainer>
              </CheckBrowserContainer>
            </RequireDesktop>
          </Async>
        )}
      </WhitelabelAppProvider>
    );
  }
}

export default App;
